import { Spinner } from "@chakra-ui/react";
import React, { memo } from "react";

interface IProps {
  fileUrl?: string | null;
  name: string;
}

const FilePdfViewer: React.FC<IProps> = ({ fileUrl, name }) => {
  if (!fileUrl) {
    return <Spinner />;
  }

  return (
    <iframe
      src={fileUrl}
      title={name}
      style={{
        width: "100%",
        height: "100%",
      }}
    />
  );
};

export default memo(FilePdfViewer);
